import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 39,
	height: 40,
	viewBox: "0 0 39 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.08984 3.64062L35.5001 35.0509",
		stroke: "#B9F833",
		strokeWidth: 7.17949
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.5 35.5H34.6026V0.5",
		stroke: "#B9F833",
		strokeWidth: 7.17949
	})]
});
export default SvgLink;
